import type { CompleteProfileForm, User } from '~/modules/auth/types';

export function checkOnboarding(user: User) {
  switch (true) {
    case !checkCompleteProfile(user, user.onboarding?.skipped_complete_profile || false):
      return 'complete-profile';
    case !checkUploadProfile(user, user.onboarding?.skipped_avatar || false):
      return 'upload-profile';
    default:
      return true;
  }
}

export function checkCompleteProfile(account: CompleteProfileForm, skipped: boolean) {
  return Boolean((account.first_name && account.last_name && account.birthdate) || skipped);
}
export function checkUploadProfile(user: User, skipped: boolean) {
  return Boolean(user.avatar) || skipped;
}
